import React from "react";
import {useSelector} from "react-redux";

import {Container} from "@pg-design/grid-module";
import {mb} from "@pg-design/helpers-css";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../app/components/breadcrumbs/Breadcrumbs";
import {IRPStore} from "../../app/rp_reducer";
import {SiteMapBox} from "../components/SiteMapBox";
import {SiteMapHeading} from "../components/SiteMapHeading";
import {siteMapLinkDefinedPrefixes, SiteMapLinkList} from "../components/SiteMapLinkList";

export const SiteMapOffersVoivodeshipList = () => {
    const voivodeshipLinks =
        useSelector((state: IRPStore) => state.siteMap.regions.voivodeship)
            ?.filter((voivodeship) => voivodeship.id <= 1000)
            .map((voivodeship) => ({
                href: rpAppLink.siteMap.offer.voivodeship({voivodeshipSlug: voivodeship.slug}),
                text: voivodeship.name
            })) || [];

    return (
        <Container>
            <Breadcrumbs
                homePageUrl={rpAppLink.base()}
                items={[
                    {name: "Mapa strony", url: rpAppLink.siteMap.base()},
                    {name: "Inwestycje", url: rpAppLink.siteMap.offer.base()}
                ]}
            />

            <article>
                <SiteMapHeading>Mapa strony - inwestycje w podziale na województwa</SiteMapHeading>
                <SiteMapBox css={[mb(4)]}>
                    <SiteMapLinkList links={voivodeshipLinks} textPrefix={siteMapLinkDefinedPrefixes.bullet} />
                </SiteMapBox>
            </article>
        </Container>
    );
};
import React from "react";
import {useSelector} from "react-redux";

import {Container} from "@pg-design/grid-module";
import {mb} from "@pg-design/helpers-css";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../app/components/breadcrumbs/Breadcrumbs";
import {IRPStore} from "../../app/rp_reducer";
import {SiteMapBox} from "../components/SiteMapBox";
import {SiteMapHeading} from "../components/SiteMapHeading";
import {siteMapLinkDefinedPrefixes, SiteMapLinkList} from "../components/SiteMapLinkList";

export const SiteMapOffersVoivodeshipList = () => {
    const voivodeshipLinks =
        useSelector((state: IRPStore) => state.siteMap.regions.voivodeship)
            ?.filter((voivodeship) => voivodeship.id <= 1000)
            .map((voivodeship) => ({
                href: rpAppLink.siteMap.offer.voivodeship({voivodeshipSlug: voivodeship.slug}),
                text: voivodeship.name
            })) || [];

    return (
        <Container>
            <Breadcrumbs
                homePageUrl={rpAppLink.base()}
                items={[
                    {name: "Mapa strony", url: rpAppLink.siteMap.base()},
                    {name: "Inwestycje", url: rpAppLink.siteMap.offer.base()}
                ]}
            />

            <article>
                <SiteMapHeading>Mapa strony - inwestycje w podziale na województwa</SiteMapHeading>
                <SiteMapBox css={[mb(4)]}>
                    <SiteMapLinkList links={voivodeshipLinks} textPrefix={siteMapLinkDefinedPrefixes.bullet} />
                </SiteMapBox>
            </article>
        </Container>
    );
};
